module.exports = __webpack_public_path__ + "media/images/pin-a30cd78a.png";